import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import NotFoundView from '../views/NotFoundView.vue'
import DataTablesView from '../views/DataTablesView.vue'
import ClientesRecomendadosRoutes from '../views/clientes-recomendados/clientes-recomendados-routes';
import ContadoresRoutes from '../views/contadores/contadores-routes';
import ContratosRoutes from '../views/contratos/contratos-routes';
import RecomendadosRoutes from '../views/recomendados/recomendados-routes';
import RevendedoresRoutes from '../views/revendedores/revendedores-routes';
import UsuariosRoutes from '../views/usuarios/usuarios-routes';
import authService from '@/services/auth.service'

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: '/bienvenida',
      component: HomeView,
      children: [
        { path: 'bienvenida', component: () => import('../views/BienvenidaView.vue') },
        { path: 'registro', component: () => import('../views/RegistroView.vue') },
        { path: 'resumen/:id', component: () => import('../views/ResumenView.vue') },
        { path: 'regalos', component: () => import('../views/simple-views/RegalosView.vue') },
        { 
          path: 'usuarios', 
          meta: { requiresAuth: true },
          children: UsuariosRoutes 
        },
        { 
          path: 'contratos', 
          meta: { requiresAuth: true },
          children: ContratosRoutes 
        },
        { 
          path: 'contadores', 
          children: ContadoresRoutes 
        },
        { 
          path: 'revendedores',
          children: RevendedoresRoutes 
        },
        { 
          path: 'recomendados',
          meta: { requiresAuth: true },
          children: RecomendadosRoutes 
        },
        { 
          path: 'clientes-recomendados', 
          meta: { requiresAuth: true },
          children: ClientesRecomendadosRoutes 
        },
        {
          path: '/actualizar-usuario',
          meta: { requiresAuth: true },
          component: () => import('../views/usuarios/ActualizarUsuarioView.vue')
        },
        { 
          path: 'info', 
          name: 'DataTables',
          redirect: 'info/contratos',
          component: DataTablesView,
          children: [
            { 
              path: 'contratos', 
              meta: { requiresAuth: true },
              component: () => import('../views/contratos/ContratosView.vue') 
            },
            { 
              path: 'contadores',
              meta: { requiresAuth: true },
              component: () => import('../views/contadores/ContadoresView.vue') 
            },
            { 
              path: 'revendedores',
              meta: { requiresAuth: true },
              component: () => import('../views/revendedores/RevendedoresView.vue')
            },
            { 
              path: 'recomendados', 
              meta: { requiresAuth: true },
              component: () => import('../views/recomendados/RecomendadosView.vue') 
            },
            { 
              path: 'clientes-recomendados', 
              meta: { requiresAuth: true },
              component: () => import('../views/clientes-recomendados/ClientesRecomendadosView.vue') 
            }
          ]
        }
      ]
    },
    {
      path: '/felicidades-recomendado',
      component: () => import('../views/simple-views/FelicidadesRecomendado.vue')
    },
    {
      path: '/felicidades-recomendado-cliente',
      component: () => import('../views/simple-views/FelicidadesRecomendadoCliente.vue')
    },
    {
      path: '/felicidades-contador',
      component: () => import('../views/simple-views/FelicidadesContador.vue')
    },
    {
      path: '/felicidades-contador',
      component: () => import('../views/simple-views/FelicidadesContador.vue')
    },
    {
      path: '/felicidades-revendedor',
      component: () => import('../views/simple-views/FelicidadesRevendedor.vue')
    },
    
    
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      path: "/*",
      name: "notFoundAll",
      component: NotFoundView
    },
    {
      path: "/not-found",
      name: "notFound",
      component: NotFoundView
    }
  ]
});

router.beforeEach((to,from,next) => {
  let reqAuth = to.meta.requiresAuth;
  if (!reqAuth) {
    next();
    return;
  }
  let isLoggedIn = authService.isLoggedIn();
  if(isLoggedIn){
    next();
  }
  else {
    next('/login')
  }
})

export default router
